/**
 * 
 * key
 * 
 */


const key = 'cHJvZHVjdERldGFpbFN0YXR1c1JlcG9ydA=='

export default key 